module.exports = __webpack_public_path__ + "assets/img/chirp-home.51c36c77.svg";